module.exports = __webpack_public_path__ + "static/media/Lock.14d86eb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Lock.svg
// module id = 230
// module chunks = 0